import { useEffect, useState } from "react";
import { nowMin } from "./time";

/** Демо-часы: тикают раз в 15 секунд, чтобы «5 мин назад» и линия «сейчас» были живыми */
export function useNow(intervalMs = 15000) {
  const [now, setNow] = useState(nowMin);
  useEffect(() => {
    const id = window.setInterval(() => setNow(nowMin()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
